<div class="m-2">
    <!-- base item.. -->
    <div class="row mx-2">
        <div class="col">
            <table>
                <tr>
                    <td>{{'export_inv_columns.personAnzeigeName' | translate}}</td>
                    <td>{{ baseItem['personAnzeigeName'] }}</td>
                </tr>
                <tr>
                    <td>{{'export_inv_columns.eventName' | translate}}</td>
                    <td>{{ baseItem['eventName'] }}</td>
                </tr>
                <tr>
                    <td>{{'export_inv_columns.eventDate' | translate}}</td>
                    <td>{{ baseItem['eventDate'] | date:'short':undefined:locale  }}</td>
                </tr>
                <tr>
                    <td>{{'export_inv_columns.huntingDistrictName' | translate}}</td>
                    <td>{{ baseItem['huntingDistrictName'] }}</td>
                </tr>
                <tr>
                    <td>{{'export_inv_columns.creationDate' | translate}}</td>
                    <td>{{ baseItem['creationDate'] | date:'short':undefined:locale }}</td>
                </tr>
                <tr>
                    <td>{{'export_inv_columns.processingStatus' | translate}}</td>
                    <td>{{ 'invite_status.'+baseItem['processingStatus'] | translate }}</td>
                </tr>
                <tr>
                    <td>{{'export_inv_columns.invitationApproved' | translate}}</td>
                    <td>{{ baseItem['invitationApproved'] | date:'short':undefined:locale }}</td>
                </tr>
                <tr>
                    <td>{{'export_inv_columns.invitationExpiration' | translate}}</td>
                    <td>{{ baseItem['invitationExpiration'] | date:'short':undefined:locale }}</td>
                </tr>
                <tr>
                    <td>{{'export_inv_columns.invitationSend' | translate}}</td>
                    <td>{{ baseItem['invitationSend'] | date:'short':undefined:locale }}</td>
                </tr>
                <tr>
                    <td>{{'export_inv_columns.invitationViewed' | translate}}</td>
                    <td>{{ baseItem['invitationViewed'] | date:'short':undefined:locale }}</td>
                </tr>
                <tr>
                    <td>{{'export_inv_columns.invitationAccepted' | translate}}</td>
                    <td>{{ baseItem['invitationAccepted'] | date:'short':undefined:locale }}</td>
                </tr>
                <tr>
                    <td>{{'export_inv_columns.invitationDeclined' | translate}}</td>
                    <td>{{ baseItem['invitationDeclined'] | date:'short':undefined:locale }}</td>
                </tr>
            </table>
        </div>
    </div>
</div>
<div *ngIf="logItems$ | async as logItems">
    <!-- create / update / delete -->
    <div *ngFor="let item of logItems" class="m-3">
        <mat-card>
            <mat-card-header>
                <mat-card-title>{{item.userDisplayName}}</mat-card-title>
                <mat-card-subtitle>{{item.creationDate | date:'short':undefined:locale}}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="item.transactions; else transactionLog">
                    <ul class="list-group">
                        <li class="list-group-item" *ngFor="let t of item.transactions">{{t.operation}} {{t.fieldName}} {{t.oldValue}} -> {{t.newValue}}</li>
                    </ul>
                </div>
                <ng-template #transactionLog>
                    <ul class="list-group">
                        <li class="list-group-item">{{item.operation}} {{item.fieldName}} {{item.oldValue}} -> {{item.newValue}}</li>
                    </ul>
                </ng-template>
            </mat-card-content>
        </mat-card>
    </div>

</div>